import { config as luminateConfig } from '@frx/frx-services';

export const useLuminateConfig = () => luminateConfig(window.location);
